<template>
  <el-button type="primary" size="mini" plain @click="pushView">
    View
  </el-button>
</template>

<script>
export default {
  props: {
    slug: String,
  },
  methods: {
    pushView() {
      window.open(`${ process.env.VUE_APP_APP_HOST }/ingredients/${ this.slug }`)
    }
  }
}
</script>
